const COLORS = {
    white: '#FFFFFF',
    black: '#000000',
    white70: '#FFFFFFB8',
    secondary: '#05B49B'
}

const theme = {
    printShop: {
        primary: "#ff5323",
        bg: "#fff8f5",
        border: "#ffe4db",
        iconBg: "#ff5323",
        accentBg: "#fff0ec",
    },
    specialist: {
        primary: "#7C3AED",
        bg: "#FAF5FF",
        border: "#E9D5FF",
        iconBg: "#7C3AED",
        accentBg: "#FAF5FF",
    },
    supplier: {
        primary: "#16a34a",
        bg: "#f0fdf8",
        border: "#c6f0dc",
        iconBg: "#16a34a",
        accentBg: "#f0fdf4",
    },
};

export {
    COLORS,
    theme
}